import React from "react";
import {Card, Statistic, Tooltip} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";
import {isNumber} from "lodash";
import {StatisticCol, StatisticTitle, WalletSummaryContainer} from "./WalletSummary.styles";
import {BlockedBalanceEditPopover} from "./blockedBalanceEditPopover/BlockedBalanceEditPopover";
import {CodLimitOffsetEditPopover} from "./codLimitOffsetEditPopover/CodLimitOffsetEditPopover";
import {UNPROCESSED_PERIOD_EARNING_TOOLTIP} from "../../../../../../constants/constants";

const statisticValueStyle = {
    letterSpacing: "-1px",
    fontWeight: 600
};

const formatStatisticValue = amount =>
    isNumber(amount)
        ? amount.toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          })
        : "0,00";

export const WalletSummary = ({
    wallet,
    courierId,
    canEditBlockedBalance = false,
    refreshWallet = () => {}
}) => {
    return (
        <Card>
            <WalletSummaryContainer gutter={[16, 16]}>
                <StatisticCol xs={24} sm={12} md={8} lg={4}>
                    <Statistic
                        title={<StatisticTitle>Toplam Bakiye</StatisticTitle>}
                        value={formatStatisticValue(wallet?.balance)}
                        precision={2}
                        suffix="₺"
                        valueStyle={statisticValueStyle}
                    />
                </StatisticCol>
                <StatisticCol xs={24} sm={12} md={8} lg={4}>
                    <Statistic
                        title={<StatisticTitle>Kullanılabilir Bakiye</StatisticTitle>}
                        value={formatStatisticValue(wallet?.availableBalance)}
                        precision={2}
                        suffix="₺"
                        valueStyle={statisticValueStyle}
                    />
                </StatisticCol>
                <StatisticCol xs={24} sm={12} md={8} lg={4}>
                    <Statistic
                        title={
                            <StatisticTitle>
                                Bloke Bakiye
                                {canEditBlockedBalance && (
                                    <BlockedBalanceEditPopover
                                        courierId={courierId}
                                        blockedBalance={wallet?.blockedBalance}
                                        onSuccess={refreshWallet}
                                    />
                                )}
                            </StatisticTitle>
                        }
                        value={formatStatisticValue(wallet?.blockedBalance)}
                        precision={2}
                        suffix="₺"
                        valueStyle={statisticValueStyle}
                    />
                </StatisticCol>
                <StatisticCol xs={24} sm={12} md={8} lg={4}>
                    <Statistic
                        title={
                            <StatisticTitle>
                                Nakit Alınabilir Sipariş Tutarı
                                {canEditBlockedBalance && (
                                    <CodLimitOffsetEditPopover
                                        courierId={courierId}
                                        cashOnDeliveryLimitOffset={
                                            wallet?.cashOnDeliveryLimitOffset
                                        }
                                        onSuccess={refreshWallet}
                                    />
                                )}
                            </StatisticTitle>
                        }
                        value={formatStatisticValue(wallet?.cashOnDeliveryLimit)}
                        precision={2}
                        suffix="₺"
                        valueStyle={{
                            ...statisticValueStyle
                        }}
                    />
                </StatisticCol>
                <StatisticCol xs={24} sm={12} md={8} lg={4}>
                    <Statistic
                        title={
                            <StatisticTitle>
                                İşlenmemiş Dönem Kazancı
                                <Tooltip title={UNPROCESSED_PERIOD_EARNING_TOOLTIP}>
                                    <InfoCircleOutlined style={{color: "#797979"}} />
                                </Tooltip>
                            </StatisticTitle>
                        }
                        value={formatStatisticValue(wallet?.unprocessedEarning)}
                        precision={2}
                        suffix="₺"
                        valueStyle={statisticValueStyle}
                    />
                </StatisticCol>
            </WalletSummaryContainer>
        </Card>
    );
};
